import { onMounted } from 'vue'

import { queueAdEvent } from '../utils/queue-ad-event'

type AdEventName = 'providerLoaded' | 'allAdsLoaded'

type AdEventCallback = ({ moltenBundle }: { moltenBundle: any }) => void

/**
 * useAdEvent composable
 * @param {AdEventName} eventName - The name of the ad event to listen for
 * @param {AdEventCallback} callback - The callback function to execute when the event is triggered
 */
export function useAdEvent (eventName: AdEventName, callback: AdEventCallback) {
  onMounted(() => {
    queueAdEvent((moltenBundle) => {
      switch (eventName) {
        case 'providerLoaded': {
          callback({ moltenBundle })
          break
        }
        case 'allAdsLoaded': {
          moltenBundle.registerAllAdsLoadedHandler(() => {
            callback({ moltenBundle })
          })
          break
        }
        default: {
          throw new Error(`Invalid ad event name: ${eventName}`)
        }
      }
    })
  })
}
